// extracted by mini-css-extract-plugin
export default {"checkIconBackground":"rating-career-paths_checkIconBackground__7IayD","card":"rating-career-paths_card__WQoCx","done":"rating-career-paths_done__xVHJk"};